module.exports = __webpack_public_path__ + "static/img/bg-career-jobs.44d036a3.jpg";